module.exports = __webpack_public_path__ + "static/img/67066G_2_R_20190709_fit.c140d1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/67066G_2_R_20190709_fit.png
// module id = riLP
// module chunks = 0